import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ContactFormsApi - axios parameter creator
 * @export
 */
const ContactFormsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/ContactForms/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/ContactForms/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ContactFormToken, options = {}) => {
            const localVarPath = `/v1/ContactForms/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContactFormToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/ContactForms/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ContactFormToken, options = {}) => {
            const localVarPath = `/v1/ContactForms/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContactFormToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactFormsApi - functional programming interface
 * @export
 */
const ContactFormsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactFormsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ContactFormToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ContactFormToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ContactFormToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ContactFormToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactFormsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContactFormsApi - factory interface
 * @export
 */
const ContactFormsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactFormsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ContactFormToken, options) {
            return localVarFp.insert(ContactFormToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {ContactFormToken} [ContactFormToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ContactFormToken, options) {
            return localVarFp.update(ContactFormToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactFormsApi - object-oriented interface
 * @export
 * @class ContactFormsApi
 * @extends {BaseAPI}
 */
class ContactFormsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormsApi
     */
    getAll(options) {
        return ContactFormsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormsApi
     */
    getById(id, options) {
        return ContactFormsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {ContactFormToken} [ContactFormToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormsApi
     */
    insert(ContactFormToken, options) {
        return ContactFormsApiFp(this.configuration).insert(ContactFormToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormsApi
     */
    remove(id, options) {
        return ContactFormsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {ContactFormToken} [ContactFormToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactFormsApi
     */
    update(ContactFormToken, options) {
        return ContactFormsApiFp(this.configuration).update(ContactFormToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ContactFormsApi, ContactFormsApiAxiosParamCreator, ContactFormsApiFactory, ContactFormsApiFp };
//# sourceMappingURL=contact-forms-api.js.map
